import { setOrderProcessName } from "features/common/layouts/cartSlice";
import { resetError } from "features/common/products/productsSlice";
// import OrderStep from 'layouts/OrderStep'
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notifyError } from "components/ToastMessage";
import Breadcrumbs from './Breadcrumbs'
import CheckoutTable from "./CheckoutTable";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ModalConfirmationCancel from "components/ModalConfirmationCancel";
import PopupRandomBuy from "components/PopupRandomBuy";
import CountdownBanner from "components/CountdownBanner";
import BubbleChat from "components/BubbleChat";
import ProgressBar from "./ProgressBar";
// import PromoBackdrop from "components/PromoBackdrop";

const MainLayouts = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector((state) => state.products);
  const { orderProcessName, productsList } = useSelector((state) => state.cart);
  const cartHasItem = productsList.length !== 0;
  const [modalConfirmation, setModalConfirmation] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (error.status && isMounted) {
      notifyError(error.msg);
      dispatch(resetError());
      navigate("/");
    }

    return () => {
      isMounted = false;
    };
  }, [error, dispatch, navigate]);

  const cancelOrderHandler = (e) => {
    setModalConfirmation(true);
  };

  const handlerCloseModal = () => {
    setModalConfirmation(false);
  };

  useEffect(() => {
    if (location.pathname === "/orderdomain") {
      const hasReseller = productsList.some(item => item.type === "reselleraccount");
      const hasHosting = productsList.some(item => item.type === "hostingaccount");
      if (hasReseller) {
        dispatch(setOrderProcessName("others"));
      } else if (hasHosting) {
        dispatch(setOrderProcessName("hosting"));
      } else {
        dispatch(setOrderProcessName("domain"));
      }
    }
    switch (location.pathname) {
      case "/orderhosting":
        dispatch(setOrderProcessName("hosting"));
        break;
      case "/migrasihosting":
        dispatch(setOrderProcessName("migrasiHosting"));
        break;
      case "/orderdomain":
        // dispatch(setOrderProcessName("domain"));
        break;
      case "/orderserver":
        dispatch(setOrderProcessName("vps"));
        break;
      case "/orderdomainbackorder":
        dispatch(setOrderProcessName("domainBackorder"));
        break;
      case "/orderproduct":
        // dispatch(setOrderProcessName("others"));
        break;
      case "/paymentmethod":
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        if (orderProcessName) {
          dispatch(setOrderProcessName(orderProcessName));
        }
        break;
      case "/ordersummary":
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        if (!orderProcessName) {
          navigate(-2);
        }
        break;
      default:
        if (process.env.NODE_ENV === "production") {
          window.location.href = "https://www.goldenfast.net";
        }
        if (process.env.NODE_ENV === "development") {
          window.location.href = "https://staging.client.goldenfast.net";
        }
        break;
    }
  }, [location, dispatch, navigate, orderProcessName, productsList]);

  return (
    <>
      <Navbar />
      <ProgressBar />
      <div id="portalCheckout">
        <div className="section-init pt-3">
          <div
            className="container-fluid container-xxl"
            style={{ minHeight: "79vh" }}
          >
            {location.pathname !== '/' && (
              <div className="row justify-content-center">
                <div className="col-12 col-md-12 col-lg-12 col-xl-11">
                  {productsList.length > 0 && <CountdownBanner />}
                  <Breadcrumbs />
                </div>
              </div>
            )}

            {/* {location.pathname !== '/' &&
							location.pathname !== '/paymentmethod' &&
							location.pathname !== '/ordersummary' && (
								<div className="row justify-content-center">
									<div className="col-12 col-md-12 col-lg-12 col-xl-8">
										<OrderStep />
									</div>
								</div>
							)}

						{location.pathname === '/paymentmethod' && (
							<div className="row justify-content-center d-none d-lg-flex">
								<div className="col-12 col-md-12 col-lg-12 col-xl-8">
									<OrderStep />
								</div>
							</div>
						)}

						{location.pathname === '/ordersummary' && (
							<div className="row justify-content-center d-none d-lg-flex">
								<div className="col-12 col-md-12 col-lg-12 col-xl-8">
									<OrderStep />
								</div>
							</div>
						)} */}

            <div className="row justify-content-center">
              <div
                className="col-12 col-md-12 col-lg-7 col-xl-7 position-relative mb-lg-0 mb-3"
                id="leftSide"
              >
                {props.children}
              </div>
              <div
                className={`col-12 col-md-12 ${
                  props.summary ? "col-lg-7 col-xl-7 mt-3" : "col-lg-5 col-xl-4"
                } checkout-sticky sticky-top`}
                id="rightSide"
                style={{ zIndex: "1000" }}
              >
                <CheckoutTable isSummaryPage={props.summary} />

                {cartHasItem && (
                  <div className="text-center mt-2">
                    <button
                      onClick={cancelOrderHandler}
                      className="btn btn-outline-secondary btn-sm hover-shadow rounded-5 px-4 w-100"
                    >
                      <p className="mb-0 fw-bold">Lihat Produk Lain</p>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirmationCancel
        show={modalConfirmation}
        onHide={handlerCloseModal}
      />
      <PopupRandomBuy />
      {/* <PromoBackdrop /> */}
      <BubbleChat productsList={productsList} />
      <Footer />
      <ToastContainer limit={3} theme="dark" />
    </>
  );
};

export default MainLayouts;
